import { render } from "./commonPartsHeader.vue?vue&type=template&id=9b274e66"
import script from "./commonPartsHeader.vue?vue&type=script&lang=js"
export * from "./commonPartsHeader.vue?vue&type=script&lang=js"

import "./commonPartsHeader.vue?vue&type=style&index=0&id=9b274e66&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__